export default __webpack_public_path__ + "static/media/mid2.3d801c58.jpg";